import { getSpaRoutes } from '@atlassian/jira-routes/src/getSpaRoutes.tsx';
import { getCodegenSpaRoutes } from '@atlassian/jira-routes/src/getCodegenSpaRoutes.tsx';
// Use `@atlassian/match-route` directly to avoid side-effects such as caching and mutating the route.
import matchRouteOrderIndependent from '@atlassian/match-route';
import { fg } from '@atlassian/jira-feature-gating';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';

const callWhenIdle = (callback: () => void) => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	if (typeof window.requestIdleCallback === 'function') {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.requestIdleCallback(callback);
	} else {
		setTimeout(callback, 3000);
	}
};
// The function is used to check the difference of matched results between the old route map and the new codegened route map.
// It is only triggered on the client side and on initial load.
export function shadowRouting() {
	if (fg('rollout-codegen-spa-route-map-shadow-routing')) {
		callWhenIdle(() => {
			try {
				// This function should only be called by jira-spa.tsx, where window is always defined.
				// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
				const pathname = window.location.pathname;
				// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
				const search = window.location.search;
				const matchedRoute = matchRouteOrderIndependent(getSpaRoutes(), pathname, search);
				const matchedRouteFromCodegenedRouteMap = matchRouteOrderIndependent(
					getCodegenSpaRoutes(),
					pathname,
					search,
				);
				if (!matchedRoute) return; // this shouldn't happen.
				if (!matchedRouteFromCodegenedRouteMap) {
					log.safeErrorWithoutCustomerData('match_route', 'fail', {
						codegened: fg('rollout-codegen-spa-route-map'),
					});
					return;
				}
				if (matchedRoute.route !== matchedRouteFromCodegenedRouteMap.route) {
					// Log the difference as details as possible to help us understand the difference.
					log.safeInfoWithoutCustomerData('match_route', 'diff', {
						newName: matchedRouteFromCodegenedRouteMap.route.name,
						newPath: matchedRouteFromCodegenedRouteMap.route.path,
						newQuery: matchedRouteFromCodegenedRouteMap.route.query?.length || 0,
						oldName: matchedRoute.route.name,
						oldPath: matchedRoute.route.path,
						oldQuery: matchedRoute.route.query?.length || 0,
						codegened: fg('rollout-codegen-spa-route-map'),
					});
				}
			} catch (e) {
				log.safeErrorWithoutCustomerData('match_route', 'fail', {
					errorMessage: e instanceof Error ? e.message : 'unknown',
					errorStack: e instanceof Error ? e.stack : 'unknown',
					errorString: typeof e?.toString === 'function' ? e.toString() : 'unknown',
					codegened: fg('rollout-codegen-spa-route-map'),
				});
			}
		});
	}
}
